import { render, staticRenderFns } from "./HttpAlarmSetupTable.vue?vue&type=template&id=08298d92"
import script from "./HttpAlarmSetupTable.vue?vue&type=script&lang=ts"
export * from "./HttpAlarmSetupTable.vue?vue&type=script&lang=ts"
import style0 from "./HttpAlarmSetupTable.vue?vue&type=style&index=0&id=08298d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports